import { ETelemetryTopOf } from 'multirpc-sdk';
import { Timeframe } from '@ankr.com/chains-list';

import { selectPrivateBlockchainsCountsMap } from 'modules/stats/store/private/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { usePrivateStats } from 'modules/stats/hooks/usePrivateStats';
import { usePrivateStatsParams } from 'modules/chains/hooks/usePrivateStatsParams';

export interface IUseChainsStatsProps {
  timeframe: Timeframe;
}

const metrics = [ETelemetryTopOf.BLOCKCHAIN];

export const useChainsPrivateStats = ({ timeframe }: IUseChainsStatsProps) => {
  const { privateStatsParams } = usePrivateStatsParams({ metrics, timeframe });

  const { loading, params } = usePrivateStats(privateStatsParams);

  const chainsCountsMap = useAppSelector(state =>
    selectPrivateBlockchainsCountsMap(state, params),
  );

  return { chainsCountsMap, loading, params };
};
